import { FetchResult, gql } from '@apollo/client';
import { apolloMutation } from '../apollo';
import {
  CheckVerificationTokenInput,
  CheckVerificationTokenMutation,
  SendVerificationTokenMutation,
  VerifyHybridTokenInput,
  VerifyHybridTokenMutation,
  VerifyOobaTokenInput,
  VerifyOobaTokenMutation,
  VerifyContractTokenInput,
  VerifyContractTokenMutation,
} from '../gql/graphql';

export interface Auth {
  sendVerificationToken(cellPhone: string): Promise<FetchResult<SendVerificationTokenMutation>>;
  checkVerificationToken(input: CheckVerificationTokenInput): Promise<FetchResult<CheckVerificationTokenMutation>>;
  verifyHybridToken(input: VerifyHybridTokenInput): Promise<FetchResult<VerifyHybridTokenMutation>>;
  verifyOobaToken(input: VerifyOobaTokenInput): Promise<FetchResult<VerifyOobaTokenMutation>>;
  verifyContractToken(input: VerifyContractTokenInput): Promise<FetchResult<VerifyContractTokenMutation>>;
}

const authService: Auth = {
  async sendVerificationToken(cellPhone: string) {
    // { cellPhone: { cellPhone: cellPhone } } is incredibly stupid
    return apolloMutation(SEND_VERIFICATION_TOKEN, { cellPhone: { cellPhone: cellPhone } }) as Promise<FetchResult<SendVerificationTokenMutation>>;
  },
  async checkVerificationToken(input: CheckVerificationTokenInput) {
    return apolloMutation(CHECK_VERIFICATION_TOKEN, { input: input }) as Promise<FetchResult<CheckVerificationTokenMutation>>;
  },
  async verifyHybridToken(input: VerifyHybridTokenInput) {
    return apolloMutation(VERIFY_HYBRID_TOKEN, { input: input }) as Promise<FetchResult<VerifyHybridTokenMutation>>;
  },
  async verifyOobaToken(input: VerifyOobaTokenInput) {
    return apolloMutation(VERIFY_OOBA_TOKEN, { input: input }) as Promise<FetchResult<VerifyOobaTokenMutation>>;
  },
  async verifyContractToken(input: VerifyContractTokenInput) {
    return apolloMutation(VERIFY_CONTRACT_TOKEN, { input: input }) as Promise<FetchResult<VerifyContractTokenMutation>>;
  },
};

export const SEND_VERIFICATION_TOKEN = gql`
  mutation sendVerificationToken($cellPhone: SendVerificationTokenInput!) {
    sendVerificationToken(input: $cellPhone) {
      status
      sendTokenErrors {
        __typename
        ... on FatalError {
          message
        }
        ... on SMSNotSent {
          message
        }
      }
    }
  }
`;

export const CHECK_VERIFICATION_TOKEN = gql`
  mutation checkVerificationToken($input: CheckVerificationTokenInput!) {
    checkVerificationToken(input: $input) {
      checkTokenErrors {
        __typename
        ... on FatalError {
          message
        }
        ... on MaxAttempts {
          message
        }
      }
    }
  }
`;

export const VERIFY_HYBRID_TOKEN = gql`
  mutation verifyHybridToken($input: VerifyHybridTokenInput!) {
    verifyHybridToken(input: $input) {
      verifyHybridTokenErrors {
        __typename
        ... on FatalError {
          message
        }
        ... on BadRequest {
          message
        }
      }
    }
  }
`;

export const VERIFY_OOBA_TOKEN = gql`
  mutation verifyOobaToken($input: VerifyOobaTokenInput!) {
    verifyOobaToken(input: $input) {
      verifyOobaTokenErrors {
        __typename
        ... on FatalError {
          message
        }
        ... on BadRequest {
          message
        }
      }
    }
  }
`;

export const VERIFY_CONTRACT_TOKEN = gql`
  mutation verifyContractToken($input: VerifyContractTokenInput!) {
    verifyContractToken(input: $input) {
      verifyContractTokenErrors {
        __typename
        ... on FatalError {
          message
        }
        ... on BadRequest {
          message
        }
      }
    }
  }
`;

export default authService;
